export const GET_ALQURANSANTRI_SUCCEED = "alquransantri/get/succeed";
export const GET_ALQURANSANTRI_REQUEST = "alquransantri/get/request";
export const GET_ALQURANSANTRI_FAILED = "alquransantri/get/failed";

export const GET_ALQURANSANTRIAWAL_SUCCEED = "alquransantri/getawal/succeed";
export const GET_ALQURANSANTRIAWAL_REQUEST = "alquransantri/getawal/request";
export const GET_ALQURANSANTRIAWAL_FAILED = "alquransantri/getawal/failed";

export const CREATE_ALQURANSANTRI_REQUEST = "alquransantri/create/request";
export const CREATE_ALQURANSANTRI_SUCCEED = "alquransantri/create/succeed";
export const CREATE_ALQURANSANTRI_FAILED = "alquransantri/create/failed";

export const DELETE_ALQURANSANTRI_REQUEST = "alquransantri/delete/request";
export const DELETE_ALQURANSANTRI_SUCCEED = "alquransantri/delete/succeed";
export const DELETE_ALQURANSANTRI_FAILED = "alquransantri/delete/failed";

export const GET_BY_ID_ALQURANSANTRI_REQUEST = "alquransantri/getid/request";
export const GET_BY_ID_ALQURANSANTRI_SUCCEED = "alquransantri/getid/succeed";
export const GET_BY_ID_ALQURANSANTRI_FAILED = "alquransantri/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_ALQURANSANTRI_REQUEST =
  "alquransantri/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_ALQURANSANTRI_SUCCEED =
  "alquransantri/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_ALQURANSANTRI_FAILED =
  "alquransantri/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_ALQURANSANTRI_REQUEST =
  "alquransantri/getbymastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_ALQURANSANTRI_SUCCEED =
  "alquransantri/getbymastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_ALQURANSANTRI_FAILED =
  "alquransantri/getbymastertahfidz/failed";

export const GET_BY_USERID_ALQURANSANTRI_REQUEST =
  "alquransantri/getbyuserid/request";
export const GET_BY_USERID_ALQURANSANTRI_SUCCEED =
  "alquransantri/getbyuserid/succeed";
export const GET_BY_USERID_ALQURANSANTRI_FAILED =
  "alquransantri/getbyuserid/failed";

export const UPDATE_ALQURANSANTRI_REQUEST = "alquransantri/update/request";
export const UPDATE_ALQURANSANTRI_SUCCEED = "alquransantri/update/succeed";
export const UPDATE_ALQURANSANTRI_FAILED = "alquransantri/update/failed";
